var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 64,
    viewBox: "0 0 217 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.048 42.48C215.048 49.256 210.316 52 205.528 52H188V32.96H205.528C210.316 32.96 215.048 35.732 215.048 42.48ZM204.52 45.952C206.648 45.952 207.6 44.748 207.6 42.48C207.6 40.212 206.648 39.008 204.52 39.008H196.232V45.952H204.52Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.306 42.536C183.606 42.718 184.646 43.134 185.4 43.784C186.154 44.434 186.544 45.422 186.544 46.748C186.544 48.152 186.154 49.296 185.4 50.154C184.646 51.012 183.398 51.636 181.63 52.052C179.862 52.468 177.444 52.676 174.402 52.676C171.334 52.676 168.916 52.468 167.2 52.026C165.484 51.61 164.236 50.908 163.482 49.972C162.728 49.036 162.312 47.762 162.26 46.15H170.736C170.788 46.774 171.126 47.216 171.698 47.476C172.27 47.736 173.18 47.866 174.402 47.866C175.65 47.866 176.586 47.762 177.158 47.554C177.73 47.346 178.042 46.93 178.042 46.332C178.042 45.786 177.782 45.396 177.314 45.188C176.82 44.98 176.118 44.876 175.234 44.876H170.97V40.664H175.234C176.066 40.664 176.716 40.586 177.184 40.378C177.652 40.196 177.886 39.832 177.886 39.286C177.886 38.766 177.6 38.376 177.028 38.168C176.456 37.96 175.598 37.856 174.402 37.856C173.258 37.856 172.426 37.986 171.88 38.22C171.308 38.454 171.022 38.818 170.97 39.338H163.014C163.066 37.856 163.482 36.66 164.262 35.75C165.042 34.866 166.238 34.19 167.876 33.774C169.514 33.358 171.698 33.124 174.402 33.124C177.106 33.124 179.316 33.332 180.98 33.696C182.644 34.06 183.866 34.658 184.646 35.49C185.426 36.322 185.816 37.44 185.816 38.792C185.816 39.884 185.504 40.716 184.906 41.288C184.282 41.86 183.424 42.224 182.306 42.38V42.536Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 43V15.8H15.72V43H4Z",
    fill: "#FF0340"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.88 15.8V43H59.12V26.52L52.56 43H42.28L35.76 26.52V43H24V15.8C29.96 15.8 35.88 15.8 41.76 15.8L47.44 30.08L53.08 15.8C59.04 15.8 64.96 15.8 70.88 15.8ZM84.4122 43H72.1722L86.0922 15.8H100.932L114.852 43H102.612L100.612 39.12H86.4122L84.4122 43ZM93.5322 23.2L89.8122 31.28H97.2122L93.5322 23.2ZM154.788 29.4C154.788 39.08 148.028 43 141.188 43H116.148V15.8H141.188C148.028 15.8 154.788 19.76 154.788 29.4ZM139.748 34.36C142.788 34.36 144.148 32.64 144.148 29.4C144.148 26.16 142.788 24.44 139.748 24.44H127.908V34.36H139.748Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22_2",
    x: 0,
    y: 15.8,
    width: 19.72,
    height: 35.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.05d5ab09f2da915f02fc039707fe2ba8.svg";
export { ForwardRef as ReactComponent };